import { useBackerLeague } from "../hooks/use-intelligence-queries.ts";

export function BackerLeagueTable() {
  const { data, isLoading, error } = useBackerLeague(20);

  if (isLoading) return <div className="intel-loading">Loading backer league…</div>;
  if (error || !data) return <div className="intel-error">Failed to load backer league</div>;

  return (
    <section className="intel-section">
      <header className="intel-section__header">
        <h3 className="intel-section__title">Top-20 backer league</h3>
        <p className="intel-section__subtitle">
          Ranked by distinct portfolio count across our 500 pre-TGE projects. Uses canonical fund
          names (Polychain/Polychain Capital variants collapse automatically). Median score = median
          alpha score across the fund's portfolio.
        </p>
      </header>

      <div className="intel-league-wrap">
        <table className="intel-league">
          <thead>
            <tr>
              <th className="intel-league__rank-head">Rank</th>
              <th>Fund</th>
              <th className="intel-league__num-head">Positions</th>
              <th className="intel-league__num-head">Median score</th>
              <th>Top category</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.fundName}>
                <td className="intel-league__rank">#{row.rank}</td>
                <td className="intel-league__fund">{row.fundName}</td>
                <td className="intel-league__num">{row.positionCount}</td>
                <td className="intel-league__num">
                  {row.medianPortfolioScore != null ? row.medianPortfolioScore.toFixed(1) : "—"}
                </td>
                <td className="intel-league__family">{row.topFamily ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
